type Translations = {
    ru: Phrases;
    en: Phrases;
};

interface Phrases {
    enable: string;
    delay: string;
    position: string;
    link: string;
    imageURL: string;
    description: string;
    noDescription: string;
    deleteSlide: string;
    edit: string;
    save: string;
    createNewSlide: string;
    fillData: string;
    noEnabledSlides: string;
    slideCarousel: string;
    slideManagement: string;
}
export const translations: Translations = {
    ru: {
        enable: 'Включить',
        delay: 'Задержка (сек)',
        position: 'Позиция',
        link: 'Ссылка',
        imageURL: 'URL картинки',
        description: 'Описание',
        noDescription: 'Нет описания',
        deleteSlide: 'Удалить слайд',
        edit: 'Редактировать',
        save: 'Сохранить',
        createNewSlide: 'Создать новый слайд',
        fillData: 'Заполните данные!',
        noEnabledSlides: 'Нет включенных слайдов',
        slideCarousel: 'Карусель слайдов',
        slideManagement: 'Управление слайдами',
    },
    en: {
        enable: 'Enable',
        delay: 'Delay (sec)',
        position: 'Position',
        link: 'Link',
        imageURL: 'Image URL',
        description: 'Description',
        noDescription: 'No description',
        deleteSlide: 'Delete slide',
        edit: 'Edit',
        save: 'Save',
        createNewSlide: 'Create new slide',
        fillData: 'Fill in the data!',
        noEnabledSlides: 'No enabled slides',
        slideCarousel: 'Slide carousel',
        slideManagement: 'Slide management',
    },
};
